import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { useLocation } from "react-router-dom";
import Nav from "./Nav";
import Footer from "./Footer";
import Cursor from "./Cursor";
import useSmoothScroll from "../../lib/useSmoothScroll";

/** 모든 페이지가 공유하는 껍데기: 스무스 스크롤, 커서, 내비, 푸터, 페이지 전환 */
export default function Shell({ children }) {
	const { pathname } = useLocation();
	useSmoothScroll();

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [pathname]);

	return (
		<div className="grain relative min-h-screen bg-surface-page">
			{/* 키보드 사용자가 내비를 건너뛰고 본문으로 바로 갈 수 있게 */}
			<a
				href="#main"
				className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[110] focus:rounded-full focus:bg-accent-solid focus:px-5 focus:py-3 focus:text-sm focus:font-medium focus:text-accent-on"
			>
				본문으로 건너뛰기
			</a>
			<Cursor />
			<Nav />
			<motion.main
				id="main"
				key={pathname}
				initial={{ opacity: 0 }}
				animate={{ opacity: 1 }}
				transition={{ duration: 0.5, ease: "easeOut" }}
			>
				{children}
			</motion.main>
			<Footer />
		</div>
	);
}
